"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Component2 = _interopRequireDefault(require("../../Component"));

var _main = _interopRequireDefault(require("../templates/main"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _range2 = _interopRequireDefault(require("lodash/range"));

var Main =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Main, _Component);

  function Main() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Main);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Main)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "template", _main["default"]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "toPrev", function () {
      var pages = _this.props.page instanceof Array ? _this.props.page : [_this.props.page],
          prevPage = pages[0] - 1;

      if (pages.length && prevPage > 0) {
        return _this.toPage(prevPage);
      } else {
        return (0, _assertThisInitialized2["default"])(_this);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "toNext", function () {
      var pages = _this.props.page instanceof Array ? _this.props.page : [_this.props.page],
          nextPage = pages[pages.length - 1] + 1;

      if (pages.length && nextPage <= _this.props.totalPages) {
        return _this.toPage(nextPage);
      } else {
        return (0, _assertThisInitialized2["default"])(_this);
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(Main, [{
    key: "toPage",
    value: function toPage(number) {
      if (typeof this.props.onChange === 'function') {
        this.props.onChange(number);
      }

      return this;
    }
  }, {
    key: "isPageSelected",
    value: function isPageSelected(number) {
      var pages = this.props.page instanceof Array ? this.props.page : [this.props.page];
      return pages.indexOf(number) >= 0;
    }
    /**
     * подготавливает ряд отображаемых страниц без сокращений и разделителей
     * [1, 2, 3] => 1, 2, 3, 4, 5, ...visiblePages
     * @param {Number|Array} selected
     * @param {Number} totalPages
     * @param {Number} maxLength
     * @return {Array}
     * @private
     */

  }, {
    key: "_getPagesRow",
    value: function _getPagesRow() {
      var selected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.page;
      var totalPages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.totalPages;
      var maxLength = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props.visiblePages;
      selected = selected instanceof Array ? selected : [selected];
      var result = [];
      var firstSelected = Number(selected[0]),
          lastSelected = Number(selected[selected.length - 1]);

      if (selected.length) {
        var restLength = totalPages > maxLength ? maxLength - selected.length : totalPages - selected.length; // selected list starts with 1

        if (firstSelected === 1) {
          result = [].concat(selected, (0, _range2["default"])(lastSelected + 1, lastSelected + 1 + restLength));
        } else if (lastSelected === totalPages) {
          result = [].concat((0, _range2["default"])(firstSelected - restLength, firstSelected), selected);
        } else {
          var i = 0,
              next,
              prev,
              beforeCounter = 1,
              afterCounter = 1;
          var beforePages = [],
              afterPages = [],
              middlePagesLength = restLength - 2; // заполняем средину, без первой и последней страницы

          for (i; i < middlePagesLength; i++) {
            next = lastSelected + afterCounter;
            prev = firstSelected - beforeCounter; // try to add after page

            if (i % 2 === 0) {
              if (next <= totalPages - 1) {
                afterPages.push(next);
                afterCounter += 1;
              } else {
                beforePages.unshift(prev);
                beforeCounter += 1;
              } // try to add before page

            } else {
              if (prev >= 2) {
                beforePages.unshift(prev);
                beforeCounter += 1;
              } else {
                afterPages.push(next);
                afterCounter += 1;
              }
            }
          } // add first page if its not exist


          if (beforePages[0] !== 1 && firstSelected !== 1) {
            beforePages.unshift(1);
          } // add last page if its not exist


          if (afterPages.length[afterPages.length - 1] !== totalPages && lastSelected !== totalPages) {
            afterPages.push(totalPages);
          }

          result = [].concat(beforePages, selected, afterPages); // результат больше максимальной длинны - необходимо сократить выбранные страницы

          if (result.length > maxLength) {
            // выбранные страницы сокращаем до первой и последней выбранной
            selected = [firstSelected, lastSelected]; // добавляем предыдущую относительно первой выбранной странице

            if (lastSelected + 1 < afterPages[afterPages.length - 1]) {
              afterPages.unshift(lastSelected + 1);
            } // добавляем следующую за последней выбранной страницей


            if (firstSelected - 1 > beforePages[0]) {
              beforePages.push(firstSelected - 1);
            }

            result = [].concat(beforePages, selected, afterPages);
          }
        }
      } else {
        result = (0, _range2["default"])(1, maxLength);
      }

      return result;
    }
  }]);
  return Main;
}(_Component2["default"]);

(0, _defineProperty2["default"])(Main, "defaultProps", {
  page: [1],
  incrementButton: true,
  decrementButton: true,
  visiblePages: 6
});
(0, _defineProperty2["default"])(Main, "propTypes", {
  page: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].number]),
  totalPages: _propTypes["default"].number.isRequired,
  incrementButton: _propTypes["default"].bool,
  decrementButton: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  visiblePages: _propTypes["default"].number,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default palette.tsXSmall
     */
    fontSize: _propTypes["default"].string,

    /**
     * @default 50%
     */
    borderRadius: _propTypes["default"].string,

    /**
     * @default ArrowRight
     */
    incrementAppearance: _propTypes["default"].func,

    /**
     * @default ArrowLeft
     */
    decrementAppearance: _propTypes["default"].func,

    /**
     * @default palette.iconOpacity
     */
    appearanceOpacity: _propTypes["default"].number,

    /**
     * @default palette.iconOpacityHover
     */
    appearanceOpacityHover: _propTypes["default"].number,

    /**
     * @default palette.iconOpacityDisabled
     */
    appearanceOpacityDisabled: _propTypes["default"].number,

    /**
     * @default palette.tInactive
     */
    idleColor: _propTypes["default"].string,

    /**
     * @default transparent
     */
    idleBackground: _propTypes["default"].string,

    /**
     * @default transparent
     */
    hoverBackground: _propTypes["default"].string,

    /**
     * @default palette.tFilled
     */
    hoverColor: _propTypes["default"].string,

    /**
     * @default palette.elAccent
     */
    selectedBackground: _propTypes["default"].string,

    /**
     * @default palette.tInversion
     */
    selectedColor: _propTypes["default"].string,

    /**
     * @default hoverColor
     */
    selectedHoverBackground: _propTypes["default"].string,

    /**
     * @default palette.tInversion
     */
    selectedHoverColor: _propTypes["default"].string,

    /**
     * @default auto
     */
    width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default auto
     */
    minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
  })
});
(0, _defineProperty2["default"])(Main, "displayName", 'Pagination');
var _default = Main;
exports["default"] = _default;